import { createApp } from 'vue';
import '@/app/styles/index.css';
import App from './App.vue';
import {
  initFaro,
  setupFaro,
  setupToast,
  setupModals,
  setupTooltips,
  setupNotifications,
  store,
  router,
  clearAuthState,
  showErrorToast,
  createUnauthorizedHandler,
  createTokenRefreshedHandler,
} from '@/app/providers';
import { initApiClient } from '@/shared/api';

initFaro();

initApiClient({
  unauthorizedHandler: createUnauthorizedHandler(),
  clearAuthStateHandler: clearAuthState,
  tokenRefreshedHandler: createTokenRefreshedHandler(),
  showErrorToastHandler: showErrorToast,
});

export const application = createApp(App).use(store).use(router);

setupNotifications(application);
setupFaro(application);
setupToast(application);
setupModals(application);
setupTooltips(application);
